import React from 'react';
import TextWithIcon from '../../../../components/Input/TextWithIcon';
import AssignmentIndOutlined from '@material-ui/icons/AssignmentIndOutlined'

export default ({createdBy}) => {
    return (<div style={{position: 'relative'}}>
                <TextWithIcon label="Created by" value={createdBy} icon={AssignmentIndOutlined}/>
            </div>)
}